import React, { FC, ReactElement, useState } from "react";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button/Button";

import { useUnfollowButtonStyles } from "./UnfollowButtonStyles";
import { UserResponse } from "../../../types/user";
import { processFollowRequest, setUserFollowing, unfollowUser } from "../../../store/ducks/user/actionCreators";
import UnfollowModal from "../../UnfollowModal/UnfollowModal";
import { useModalWindow } from "../../../hook/useModalWindow";
import { setFollowToUsersState } from "../../../store/ducks/users/actionCreators";
import { setFollowToUsersSearchState } from "../../../store/ducks/usersSearch/actionCreators";
import { useUserFollow } from "../../../context/UserFollowContext";
import { useLocation } from "react-router-dom";

interface UnfollowButtonProps {
    user?: UserResponse;
}

const UnfollowButton: FC<UnfollowButtonProps> = ({ user }): ReactElement => {
    const classes = useUnfollowButtonStyles();
    const dispatch = useDispatch();
    const { handleFollowRecord } = useUserFollow();
    const location = useLocation();
    const [btnText, setBtnText] = useState<string>("Following");
    const { visibleModalWindow, onOpenModalWindow, onCloseModalWindow } = useModalWindow();

    const handleClickOpenUnfollowModal = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        onOpenModalWindow();
    };

    const handleUnfollow = (): void => {
        if (user?.isPrivateProfile && !user.isFollower) {
            dispatch(processFollowRequest(user!.id));
        } else {
            dispatch(unfollowUser({ userId: user!.id }));
            onCloseModalWindow();
            handleFollowRecord({
                userId: user!.id,
                isFollow: false,
                path: location.pathname
            });
        }
    };

    return (
        <>
            <Button
                className={classes.containedButton}
                onClick={handleClickOpenUnfollowModal}
                onMouseOver={() => setBtnText("Unfollow")}
                onMouseLeave={() => setBtnText("Following")}
                color="primary"
                variant="contained"
                size="small"
            >
                {btnText}
            </Button>
            <UnfollowModal
                fullName={user?.fullName!}
                visible={visibleModalWindow}
                onClose={onCloseModalWindow}
                handleUnfollow={handleUnfollow}
            />
        </>
    );
};

export default UnfollowButton;
